<div class="orbits-config-preview" fxLayout="column" fxFill>
  <div class="orbits-config-preview_type" fxLayout="column" fxLayoutAlign="space-between start">
    <div class="orbits-config-preview_type-title">Select the type of item:</div>
    <div fxLayout="row wrap">
      <button mat-stroked-button class="orbits-config-preview_type-types" *ngFor="let orbitItem of orbitItems">
        {{ orbitItem.name }}
      </button>
    </div>
  </div>
  <div class="orbits-config-preview_tag" fxLayout="column" fxLayoutAlign="space-between stretch">
    <div class="orbits-config-preview_tag-title">Select the tag to identify the item:</div>
    <form fxLayout="column">
      <input class="orbits-config-preview_form-input">
    </form>
  </div>
  <div class="orbits-config-preview_warm" fxLayout="column" fxLayoutAlign="space-between stretch">
    <div class="orbits-config-preview_warm-title">How warm is this?</div>
    <div class="orbits-config-preview_warm-slider">
      <mat-slider min="1" step="1" max="11" class="orbits-config-preview_warm-slider-range"></mat-slider>
    </div>
  </div>
</div>
